import {Box, CircularProgress} from "@mui/material"
import React, {useEffect, useState} from "react"
import {useAuth} from "react-oidc-context"
import TomClient from "../services/tomClient"
import {applyBlankoLogin} from "../misc/auth-functions"
import {userManager} from "../../src/AppWrapper"

const isTokenExpired = (user) => {
    if (!user) return true
    if (typeof user.expired === "boolean") return user.expired
    if (typeof user.expires_at === "number") return user.expires_at * 1000 <= Date.now()
    return false
}

const Gatekeeper = ({children}) => {
    const auth = useAuth()
    const [isAuthorized, setIsAuthorized] = useState(false)

    const accessToken = auth.user?.access_token
    const tokenExpired = isTokenExpired(auth.user)

    useEffect(() => {
        if (accessToken && !tokenExpired) {
            TomClient.setToken(accessToken)
            setIsAuthorized(true)
        }
    }, [accessToken, tokenExpired])

    useEffect(() => {
        const handleSilentRenewError = () => {
            if (globalThis._env_.AUTH_USER) {
                applyBlankoLogin(userManager)
            } else {
                userManager.signinRedirect()
            }
        }
        userManager.events.addSilentRenewError(handleSilentRenewError)
        return () => userManager.events.removeSilentRenewError(handleSilentRenewError)
    }, [])

    useEffect(() => {
        if (globalThis._env_.AUTH_USER && (!accessToken || tokenExpired)) {
            applyBlankoLogin(userManager)
            return
        }

        if (accessToken && tokenExpired) {
            userManager.signinSilent().catch(() => {
                userManager.signinRedirect({
                    state: {returnTo: globalThis.location.pathname},
                    extraQueryParams: {
                        kc_idp_hint: globalThis._env_.KC_IDP_HINT,
                    },
                })
            })
            return
        }

        if (!auth.isAuthenticated && !auth.isLoading) {
            auth.signinRedirect({
                state: {returnTo: globalThis.location.pathname},
                extraQueryParams: {
                    kc_idp_hint: globalThis._env_.KC_IDP_HINT,
                },
            })
        }
    }, [auth.isAuthenticated, auth.isLoading, accessToken, tokenExpired])

    if (auth.isLoading || (accessToken && tokenExpired)) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="100vh">
                <CircularProgress/>
            </Box>
        )
    }
    return isAuthorized ? children : null
}

export default Gatekeeper
